export const commandPermissions = {
  ACCEPT_CHARGING_STATION: 'cpms.accept-charging-station',
  BLOCK_CHARGING_STATION: 'cpms.block-charging-station',
  CLEAR_CREDENTIALS: 'cpms.clear-charging-station-credentials',
  CONFIGURE: 'cpms.configure-charging-station',
  DELETE_CHARGING_STATION: 'cpms.delete-charging-station',
  FORCE_STOP_TRANSACTION: 'cpms.force-stop-charging-station-transaction',
  GENERATE_CREDENTIALS: 'cpms.request-cs-generate-credentials',
  SET_CREDENTIALS: 'cpms.set-charging-station-credentials',
  GET_CONFIGURATION: 'cpms.request-cs-get-configuration',
  GET_FULL_CONFIGURATION: 'cpms.request-cs-get-full-configuration',
  GET_LOG: 'cpms.request-cs-get-log',
  MOVE_CHARGING_STATION: 'cpms.move-charging-station',
  OVERRIDE_OCPI_EVSE_STATUS: 'cpms.override-charging-station-evse-status',
  PLACE_CHARGING_STATION: 'cpms.place-charging-station',
  REMOVE_CHARGING_STATION_FROM_LOCATION: 'cpms.remove-charging-station-from-location',
  REQUEST_CHARGING_STATION_CHANGE_AVAILABILITY: 'cpms.request-cs-change-availability',
  RESET_CHARGING_STATION: 'cpms.request-cs-reset',
  SET_CONFIGURATION: 'cpms.request-cs-set-configuration',
  SET_CUSTOM_IDENTIFIER: 'cpms.set-charging-station-custom-identifier',
  START_TRANSACTION: 'cpms.request-cs-start-transaction',
  STOP_TRANSACTION: 'cpms.request-cs-stop-transaction',
  TRIGGER_MESSAGE: 'cpms.request-cs-trigger-message',
  UNBLOCK_CHARGING_STATION: 'cpms.unblock-charging-station',
  UNLOCK_CONNECTOR: 'cpms.request-cs-unlock-connector',
  UPDATE_CONNECTOR_STATICS: 'cpms.update-charging-station-connector-statics',
  UPDATE_EVSE_STATICS: 'cpms.update-charging-station-evse-statics',
  UPDATE_FIRMWARE: 'cpms.request-cs-firmware-update'
};
